import { render, staticRenderFns } from "./imageBannerSetting.vue?vue&type=template&id=adf8559c&scoped=true"
import script from "./imageBannerSetting.vue?vue&type=script&lang=js"
export * from "./imageBannerSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf8559c",
  null
  
)

export default component.exports